<template>
  <div class="interaction-body answered free-response free-response-answered">
    <div
      class="px-1rem pt-2 pb-3 pp-interaction-body"
      v-html="localInteractionAttempt.responseText"
    ></div>
    <InteractionAttachments :attachments="localInteractionAttempt.interactionAttemptAttachments" />
    <text-box
      v-if="feedback.length"
      color-key="ungraded"
      title="Feedback"
      :text="feedback"
      :indent="false"
      tabindex="0"
      :aria-label="`Interaction answer feedback: ${feedback.length ? feedback.stripHTML(['img', 'Image']) : ''}`"
      :attachments="localInteraction.interactionFeedbackAttachments"
    ></text-box>
    <div v-if="localInteractionAttempt.comment && userType !== 'teacher'" class="instructor-feedback pa-3 ma-2">
      <p class="font-weight-bold">Feedback from instructor:</p>
      <div v-html="localInteractionAttempt.comment"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'FreeResponseAnsweredInteractionBody',
  components: {
    TextBox,
    InteractionAttachments,
  },
  mixins: [
    Interaction,
  ],
  props: {
    interactionAttempt: {
      type: Object,
      required: true,
    },
  },
  computed: {
    feedback() {
      return _.get(this, 'localInteraction.config.feedback', '');
    },
  },
};
</script>

<style lang="scss">
.instructor-feedback {
  background-color: #E5E5E5;
}

.instructor-feedback p {
  color: black;
}
</style>